// en, de, fr, pt
export default {
	en: {
		invoiceNumber:"Number",

		NotInList:"Barcode is not in the list",
		GreaterThanQuantity:"The scanned quantity cannot be greater than the order quantity.",

		Harvest: "Harvest",
		Appendant: "Appendant",

		OrderItemBarcode: " Item Barcode",
		OrderItemId: " Item Id",
		OrderItemSellerCode: " Item Seller Code",
		OrderItemMarketPlaceCode: " Item MarketPlace Code",
		OrderItemName: " Item Name",
		OrderItemPrice: "Item Price",
		OrderItemQuantity: "Item Quantity",
		CompleteOrder: "Complete Order",

		ClearList: "Clear List",
		ProductItemList: "Product Item List",
		CustumerBalance: "Company Balance",
		SelectedOrdersTotalPrice: "Total amount of selected orders ",

		PleaseIncreaseBalance: "Please increase your balance",
		SelectedTotalHigerThenBalance: "The total amount of selected orders cannot be greater than the current balance!",
		ConfirmToSelected: "Please make a selection.",

		AreYSure: "Are you sure?",
		CantUndo: "You cannot undo this.",
		ConfirmToInvoiceInfo: "The selected orders will be invoiced.",
		OrdersToInvoice: "To Invoice",

		Cargo: "Cargo",
		Recepient: "Recepient",

		SellerCode: "Seller Code",
		Subtotal: "Subtotal",

		PullStock: "Pull Stock",
		TotalActions: "Total Actions",
		OrderDetails: "Order Details",

		actWarning: "The debit and credit section cannot be empty.",

		Payee: "Payee",
		CreateDate: "Create Date",

		eArchiveClientKey: "E-Archive Client Key",
		eArchiveClientId: "E-Archive Client Id",
		Brand: "Brand",
		Prefix: "Prefix Kodu",

		PullOrder: "Pull Oder",
		AddWholeExcel: "Add Bulk Stock",

		Download: "Download",
		SampleExcel: "Sample Excel Template",

		AddExcel: "Add With Excel",
		AddNewDepotSupplier: "Add Supply Depot",

		DepotCompanyInfoName: "Marketplace Name",
		DepotCompanyName: "Company Name",
		DepotName: "Storehouse Name",
		DepotNo: "Storehouse No",
		UsingDropShiping: "Supplier Storehouse",

		DropShipingDepot: "Supplier Storehouse",
		DropShiping: "Supplier Situation",
		TotalAct: "Add Bulk Stock Transaction",
		OrderList: "Order List",
		Order: "Order",

		"StockAct": "Stock Actions",
		CustomerAct: "Customer Actions",

		"Actions": "Actions",

		"Account": "Account",
		"Currency": "Currency",
		"Vat": "Vat",
		"Other": "Other",
		"CargoDefinationId": "Cargo Defination",
		"Price": "Price",
		"ShippingType": "Shipping Type",
		"ShippingDay": "Shipping Day",
		"CompanyId": "Company",
		"DepotId": "Storehouse",
		"addCargo": "Cargo Definition",
		"PalletDetails": "Pallet Details",
		"UserCreate": "User Create",
		"Detail": "Detail",
		"AddBarcode": "Add Barcode",
		"Address": "Address",
		"Contact": "Contact",
		"Special": "Special",
		"Tax": "Tax",
		"General": "General",
		"AddStock": "Add Stock",
		"AddPalletItems": "Add Pallet Items",
		"Clear": "Clear",
		"PalletCreate": "Pallet Create",
		"PalletNo": "Pallet No",
		"StockCode": "Stock Code",
		"Barcode": "Barcode",
		"Quantity": "Quantity",
		"PalletId": "Pallet",
		"Height": "Height",
		"Width": "Width",
		"Depth": "Depth",
		Dept: "Dept",

		"Weight": "Weight",
		"PalletIsOpen": "Is Open",
		"PalletJobDone": "Pallet Job Done",
		"ProductTrackingId": "Product Tracking",
		"ProductTrackingName": "Product Tracking Name",
		"ProductTrackingDescription": "Product Tracking Description",
		"ProductTrackingType": "Product Tracking Type",
		"ProductTrackingNo": "Product Tracking No",
		"StockTracking": "Stock Tracking",
		"StockTrackingList": "Stock Tracking List",
		"IsTracking": "Is Tracking",
		"Company": "Company",
		"Stock": "Stock",
		"StorehouseManagement": "Storehouse Management",
		"CompanyManagement": "Company Management",
		"Validate": "Check for empty field",
		"ValidateStockIsinCard": "",
		"EmployeeAddNew": "Employee Add New",
		"EmployeeId": "Employee",
		"EmployeeNo": "Employee No",
		"EmployeeName": "Employee Name",
		"FisrtName": "First Name",
		"LastName": "Last Name",
		"EnteryDate": "Entry Date",
		"ExitDate": "Exit Date",
		"SpecCodeUnvan": "Special Code Title",
		"CompnayId": "Company",
		"GroupGode": "Group Code",
		"List": "List",
		"StockBarcodeId": "Stock Barcode",
		"UnitId": "Unit",
		"ItemNo": "Item",
		"BarcodeType": "Barcode Type",
		"Barcode": "Barcode",
		"AddStockBarcode": "Add Stock Barcode",
		"StockId": "Stock",
		"CustomerStockNo": "Customer Stock No",
		"Wholesale": "Wholesale",
		"Languages": "Languages",
		"Storehouse": "Storehouse",
		"StoreHosueName": "Storehouse Name",
		"StoreHosueId": "Storehouse Detail",
		"StoreHosueNo": "Storehouse Detail No",
		"StorehosueName": "Storehouse Detail Name",
		"Disdance": "Disdance",
		"Floor": "Floor",
		"Hall": "Hall",
		"Preference": "Preference",
		"MyProperty": "My Property",
		"DepotId": "Storehouse",
		"CompanyInfo": "Company Information",
		"CompanyInfoName": "Company Information Name",
		"Stockno": "Stock No",
		"StockName": "Stock Name",
		"SpecCode3": "Special Code 3",
		"SpecCode4": "Special Code 4",
		"SpecCode5": "Special Code 5",
		"SpecCode6": "Special Code 6",
		"SpecCode7": "Special Code 7",
		"SpecCode8": "Special Code 8",
		"SpecCode9": "Special Code 9",
		"SpecCode10": "Special Code 10",
		"Debit": "Debit",
		"Credit": "Credit",
		"RemTotal": "Balance Total",
		"RemType": "Balance Type",
		"CurrCode": "Currency Code",
		"CurrDebit": "Currency Debit",
		"CurrCredit": "Currency Credit",
		"CurrRemTotal": "Currency Balance Total",
		"CurrRemType": "Currency Balance Type",
		"QEntery": "Entry",
		"QExit": "Exit",
		"QRem": "Balance Quantity",
		"QRem2": "Balance Quantity 2",
		"QRem3": "Balance Quantity 3",
		"QReserve": "Reserve Quantity",
		"QReserve2": "Reserve Quantity 2",
		"QReserve3": "Reserve Quantity 3",
		"QDepot": "Storehouse Quantity",
		"StockName2": "Stock Name 2",
		"UnitId": "Unit",
		"VatSales": "Vat Sales",
		"VatPurChase": "Vat Purchase",
		"QuantityMin": "Quantity Min",
		"QuantityMax": "Quantity Max",
		"minOrderQuantity": "Min Order Quantity",
		"taxPrivate": "Tax Private",
		"taxPrivateTotal": "Tax Private Total",
		"ordersLevel": "Orders Level",
		"actSupplierId": "Supplier",
		"packageQuantity": "Package Quantity",
		"customerStockNo": "Customer Stock No",
		"msg": "msg",
		"minReqQuantity": "Min Req Quantity",
		"transCode": "Trans Code",
		"origin": "Origin",
		"qtyTree": "Quantity Tree",
		"depotId": "Storehouse",
		"FirstNameRequired": "First Name is required",
		"MinRequired5": "Must have no less than 5 characters",
		"shippingTypeRequired": "Shipping Type is Required",
		"shippingDayRequired": "Shipping Day is Required",
		"priceRequired": "Price is Required",
		"ProductTrackingNameRequired": "Product Tracking Name is Required",
		"ProductTrackingNoNameRequired": "Product Tracking No is Required",
		"ProductTrackingTypeNameRequired": "Product Tracking Type is Required",
		"ProductTrackingDescriptionNameRequired": "Product Tracking Description is Required",
		"RoleRequired": "Role is required",
		"StocknoRequired": "Stock No is required",
		"stocknameRequired": "Stock Name is required",
		"DepotNoRequired": "Store House number is required.",
		"DepotNameRequired": "Store House name is required.",
		"LastNameRequired": "Last Name is Required",
		"EmployeeNameRequired": "Employee Name is Required",
		"EmployeeNoRequired": "Employee No is Required",
		"storehosueNameRequired": "Storehouse Detail Name is Required",
		"storeHosueNoRequired": "Storehouse Detail No is Required",
		"customerStockNoRequired": "Customer Stock No is Required",
		"StorehosueNameRequired": "Storehouse Name is Required",
		"FloorRequired": "Floor is Required",
		"HallRequired": "Hall is Required",
		"PreferenceRequired": "Preference is Required",
		"PreferenceMinRequired": "Preference must be at least 3 characters",
		"PreferenceMaxRequired": "Preference may not be greater than 30 characters",
		"PreferenceNumRequired": "Preference must be a number",
		"CompanyInfoNameRequired": "Company Information Name is Required",
		"SpecCode3Required": "Special Code 3 is Required",
		"SpecCode4Required": "Special Code 4 is Required",
		"SpecCode5Required": "Special Code 5 is Required",
		"SpecCode6Required": "Special Code 6 is Required",
		"SpecCode7Required": "Special Code 7 is Required",
		"SpecCode8Required": "Special Code 8 is Required",
		"SpecCode9Required": "Special Code 9 is Required",
		"SpecCode10Required": "Special Code 10 is Required",
		"DebitRequired": "Debit is Required",
		"CreditRequired": "Credit is Required",
		"RemTotalRequired": "Balance Total is Required",
		"RemTypeRequired": "Balance Type is Required",
		"CurrCodeRequired": "Currency Code is Required",
		"CurrDebitRequired": "Currency Debit is Required",
		"CurrCreditRequired": "Currency Credit is Required",
		"CurrRemTotalRequired": "Currency Balance Total is Required",
		"CurrRemTypeRequired": "Currency Balance Type is Required",
		"QEnteryRequired": "Entry is Required",
		"QExitRequired": "Exit is Required",
		"QRemRequired": "Balance Quantity is Required",
		"QRem2Required": "Balance Quantity 2 is Required",
		"QRem3Required": "Balance Quantity 3 is Required",
		"QReserveRequired": "Reserve Quantity is Required",
		"QReserve2Required": "Reserve Quantity 2 is Required",
		"QReserve3Required": "Reserve Quantity 3 is Required",
		"QDepotRequired": "Storehouse Quantity is Required",
		"StockName2Required": "Stock Name 2 is Required",
		"UnitIdRequired": "Unit is Required",
		"VatSalesRequired": "Vat Sales is Required",
		"VatPurChaseRequired": "Vat Purchase is Required",
		"QuantityMinRequired": "Quantity Min is Required",
		"QuantityMaxRequired": "Quantity Max is Required",
		"minOrderQuantityRequired": "Min Order Quantity is Required",
		"taxPrivateRequired": "Tax Private is Required",
		"taxPrivateTotalRequired": "Tax Private Total is Required",
		"ordersLevelRequired": "Orders Level is Required",
		"actSupplierIdRequired": "Supplier is Required",
		"packageQuantityRequired": "Package Quantity is Required",
		"customerStockNoRequired": "Customer Stock No is Required",
		"msgRequired": "Message is Required",
		"minReqQuantityRequired": "Min Req Quantity is Required",
		"transCodeRequired": "Trans Code is Required",
		"originRequired": "Origin is Required",
		"qtyTreeRequired": "Quantity Tree is Required",
		"depotIdRequired": "Storehouse is Required"
	},
	de: {


		SpecCode: "",
		GroupCode: "",
		UPDATE: "",
		Contacts: "",
		CompanyNo: "",
		CompanyName: "",
		Customer: "",
		CustomerList: "",
		AddNew: "neue hinzufügen",
		UserDefinition: "Benutzererstellung",
		Save: "Speichern",
		RoleName: "Rollenname: ",
		RoleDefinition: "Rollendefinition",
		SearchNotFound: "Es gab keine Ergebnisse.",
		searchTitle: "Suchen...",
		Logout: "Ausloggen",
		Dashboard: "Instrumententafel",
		eCommerce: "eCommerce",
		Apps: "Apps",
		Todo: "Machen",
		Chat: "Plaudern",
		Email: "Email",
		Calendar: "Kalender",
		FullCalendar: "Calendrier completVollständiger Kalender",
		SimpleCalendar: "Einfacher Kalender",
		Shop: "Geschäft",
		ItemDetails: "Artikeldetails",
		Cart: "Wagen",
		WishList: "Wunschzettel",
		Checkout: "Auschecken",
		UI: "UI",
		DataList: "Datenliste",
		ListView: "Listenansicht",
		ThumbView: "Daumenansicht",
		Grid: "Gitter",
		Vuexy: "Vuexy",
		Vuesax: "Vuesax",
		Tailwind: "Tailwind",
		Colors: "Farben",
		Card: "Karte",
		Basic: "Basic",
		Statistics: "Statistiken",
		Analytics: "Analytics",
		CardActions: "Kartenaktionen",
		CardColors: "Kartenfarben",
		Table: "Tabelle",
		agGridTable: "agGrid-Tabelle",
		Components: "Komponenten",
		Alert: "Warnen",
		Avatar: "Benutzerbild",
		Badge: "Abzeichen",
		Breadcrumb: "Breadcrumb",
		Button: "Taste",
		ButtonGroup: "Schaltflächengruppe",
		Chip: "Chip",
		Collapse: "Zusammenbruch",
		Dialogs: "Dialoge",
		Divider: "Teiler",
		DropDown: "Dropdown-Liste",
		List: "Liste",
		Loading: "Wird geladen",
		Navbar: "Navbar",
		Notifications: "Benachrichtigungen",
		Pagination: "Seitennummerierung",
		Popup: "Pop-up",
		Progress: "Fortschritt",
		Sidebar: "Seitenleiste",
		Slider: "Schieberegler",
		Tabs: "Tabs",
		Tooltip: "QuickInfo",
		Upload: "Hochladen",
		FormsAndTable: "Formulare und Tabelle",
		FormElements: "Formularelemente",
		Select: "Wählen",
		Switch: "Schalter",
		Checkbox: "Ankreuzfeld",
		Radio: "Radio",
		Input: "Eingang",
		NumberInput: "Nummer eingeben",
		Textarea: "Textbereich",
		FormLayouts: "Formularlayouts",
		FormWizard: "Formzauberer",
		FormValidation: "Formularvalidierung",
		FormInputGroup: "Formulareingabegruppe",
		Pages: "Seiten",
		Authentication: "Authentifizierung",
		Login: "Anmeldung",
		Register: "Registrieren",
		ForgotPassword: "Passwort vergessen",
		ResetPassword: "Passwort zurücksetzen",
		LockScreen: "Bildschirm sperren",
		Miscellaneous: "Verschiedenes",
		ComingSoon: "Demnächst",
		Error: "Error",
		404: "404",
		500: "500",
		NotAuthorized: "Nicht berechtigt",
		Maintenance: "Instandhaltung",
		Profile: "Profil",
		User: "Benutzer",
		View: "Aussicht",
		Edit: "Bearbeiten",
		UserSettings: "Benutzereinstellungen",
		Invoice: "Rechnung",
		FAQ: "FAQ",
		Search: "Suche",
		KnowledgeBase: "Wissensbasis",
		ChartsAndMaps: "Diagramme und Karten",
		Charts: "Diagramme",
		ApexCharts: "Apex Charts",
		chartjs: "chartjs",
		echarts: "echarts",
		chartist: "chartist",
		GoogleMap: "Google Karte",
		Extensions: "Erweiterungen",
		QuillEditor: "Quill-Editor",
		DragAndDrop: "Ziehen und loslassen",
		Datepicker: "Datumsauswahl",
		DatetimePicker: "Datum / Uhrzeit-Auswahl",
		AccessControl: "Zugangskontrolle",
		I18n: "I18n",
		Carousel: "Karussell",
		Clipboard: "Zwischenablage",
		ContextMenu: "Kontextmenü",
		StarRatings: "Sterne Bewertungen",
		Autocomplete: "Autovervollständigung",
		Tree: "Baum",
		// "Import/Export": "Einführen/Export",
		Import: "Einführen",
		Export: "Export",
		ExportSelected: "Auswahl exportieren",
		Others: "Andere",
		MenuLevels: "Menüebenen",
		MenuLevel2p1: "Menüebene 2.1",
		MenuLevel2p2: "Menüebene 2.2",
		MenuLevel3p1: "Menüebene 3.1",
		MenuLevel3p2: "Menüebene 3.2",
		DisabledMenu: "Deaktiviertes Menü",
		Support: "Unterstützung",
		Documentation: "Dokumentation",
		RaiseSupport: "Unterstützung erheben",
		demoTitle: "Kartentitel",
		demoText: "Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen."
	},
	fr: {
		SpecCode: "",
		GroupCode: "",
		UPDATE: "",
		Contacts: "",
		CompanyNo: "",
		CompanyName: "",
		Customer: "",
		CustomerList: "",
		AddNew: "Ajouter nouveau",
		UserDefinition: "création d'utilisateur",
		Save: "Sauvegarder",
		RoleName: "Nom de rôle: ",
		RoleDefinition: "Définition de rôle",
		SearchNotFound: "Il n'y a pas eu de résultats.",
		searchTitle: "Recherche...",
		Logout: "Se déconnecter",
		Dashboard: "Tableau de bord",
		eCommerce: "commerce électronique",
		Apps: "Applications",
		Todo: "Faire",
		Chat: "Bavarder",
		Email: "Email",
		Calendar: "Calendrier",
		FullCalendar: "Calendrier complet",
		SimpleCalendar: "Calendrier simple",
		Shop: "Boutique",
		ItemDetails: "Détails de l\"article",
		Cart: "Chariot",
		WishList: "Liste de souhaits",
		Checkout: "Check-out",
		UI: "UI",
		DataList: "Liste de données",
		ListView: "Voir la liste",
		ThumbView: "Thumb View",
		Grid: "la grille",
		Vuexy: "Vuexy",
		Vuesax: "Vuesax",
		Tailwind: "Tailwind",
		Colors: "Couleurs",
		Card: "Carte",
		Basic: "De base",
		Statistics: "Statistiques",
		Analytics: "Analytique",
		CardActions: "Actions de carte",
		CardColors: "Couleurs de la carte",
		Table: "Table",
		agGridTable: "tableau agGrid",
		Components: "Composants",
		Alert: "Alerte",
		Avatar: "Avatar",
		Badge: "Badge",
		Breadcrumb: "Breadcrumb",
		Button: "Bouton",
		ButtonGroup: "Groupe de boutons",
		Chip: "Puce",
		Collapse: "Effondrer",
		Dialogs: "Dialogues",
		Divider: "Diviseur",
		DropDown: "Menu déroulant",
		List: "liste",
		Loading: "Chargement",
		Navbar: "Barre de navigation",
		Notifications: "Les notifications",
		Pagination: "Pagination",
		Popup: "Apparaitre",
		Progress: "Le progrès",
		Sidebar: "Barre latérale",
		Slider: "Curseur",
		Tabs: "Onglets",
		Tooltip: "Info-bulle",
		Upload: "Télécharger",
		FormsAndTable: "Formulaires et tableau",
		FormElements: "Éléments de formulaire",
		Select: "Sélectionner",
		Switch: "Commutateur",
		Checkbox: "Case à cocher",
		Radio: "Radio",
		Input: "Contribution",
		NumberInput: "Nombre d\"entrée",
		Textarea: "Textarea",
		FormLayouts: "Dispositions de formulaire",
		FormWizard: "Assistant de formulaire",
		FormValidation: "Validation du formulaire",
		FormInputGroup: "Groupe de saisie de formulaire",
		Pages: "Pages",
		Authentication: "Authentification",
		Login: "S\"identifier",
		Register: "registre",
		ForgotPassword: "Mot de passe oublié",
		ResetPassword: "réinitialiser le mot de passe",
		LockScreen: "Écran verrouillé",
		Miscellaneous: "Divers",
		ComingSoon: "Arrive bientôt",
		Error: "Erreur",
		404: "404",
		500: "500",
		NotAuthorized: "Pas autorisé",
		Maintenance: "Entretien",
		Profile: "Profil",
		User: "Utilisateur",
		View: "Vue",
		Edit: "Modifier",
		UserSettings: "Paramètres utilisateur",
		Invoice: "Facture d\"achat",
		FAQ: "FAQ",
		Search: "Chercher",
		KnowledgeBase: "Base de connaissances",
		ChartsAndMaps: "Graphiques Et Cartes",
		Charts: "Graphiques",
		ApexCharts: "Apex Charts",
		chartjs: "chartjs",
		echarts: "echarts",
		chartist: "chartist",
		GoogleMap: "Google Carte",
		Extensions: "Extensions",
		QuillEditor: "Éditeur de piquants",
		DragAndDrop: "Drag & Drop",
		Datepicker: "Sélecteur de date",
		DatetimePicker: "Sélecteur de date / heure",
		AccessControl: "Contrôle d\"accès",
		I18n: "I18n",
		Carousel: "Carrousel",
		Clipboard: "Presse-papiers",
		ContextMenu: "Menu contextuel",
		StarRatings: "Classement par étoiles",
		Autocomplete: "Terminé automatiquement",
		Tree: "Arbre",
		// "Import/Export": "Importation/Exportation",
		Import: "Importation",
		Export: "Exportation",
		ExportSelected: "Exporter sélectionné",
		Others: "Autre",
		MenuLevels: "Niveaux de menu",
		MenuLevel2p1: "Niveau de menu 2.1",
		MenuLevel2p2: "Niveau de menu 2.2",
		MenuLevel3p1: "Niveau de menu 3.1",
		MenuLevel3p2: "Niveau de menu 3.2",
		DisabledMenu: "Menu désactivé",
		Support: "Soutien",
		Documentation: "Documentation",
		RaiseSupport: "Augmenter le soutien",
		demoTitle: "Titre de la carte",
		demoText: "Le gâteau au sésame s\"enclenche au petit pain au pain d\"épices danois J\"adore le pain d\"épices. Tarte aux pommes et jujubes chupa chups muffin halvah sucette. Tiramisu gâteau au chocolat gâteau d\"avoine tiramisu prune sucre. Donut tarte sucrée gâteau à l\"avoine dragée gouttes de fruits gâteau au citron en barbe à papa."
	},
	pt: {
		Status: "",
		SpecCode: "",
		GroupCode: "",
		UPDATE: "",
		Contacts: "",
		CompanyNo: "",
		CompanyName: "",
		Customer: "",
		CustomerList: "",
		AddNew: "Adicionar Novo",
		UserDefinition: "Criação de usuário",
		Save: "Salvar",
		RoleName: "Nome do papel: ",
		RoleDefinition: "Definição de papel",
		SearchNotFound: "Não houve resultados.",
		searchTitle: "Procurar...",
		Logout: "Sair",
		Dashboard: "painel de controle",
		eCommerce: "comércio eletrônico",
		Apps: "APPS",
		Todo: "Façam",
		Chat: "Bate-papo",
		Email: "O email",
		Calendar: "Calendário",
		FullCalendar: "Calendário Completo",
		SimpleCalendar: "Calendário Simples",
		Shop: "fazer compras",
		ItemDetails: "Detalhes do item",
		Cart: "Carrinho",
		WishList: "Lista de Desejos",
		Checkout: "Confira",
		UI: "UI",
		DataList: "Lista de dados",
		ListView: "Exibição de lista",
		ThumbView: "Thumb View",
		Grid: "Grade",
		Vuexy: "Vuexy",
		Vuesax: "Vuesax",
		Tailwind: "Tailwind",
		Colors: "Cores",
		Card: "Cartão",
		Basic: "Basic",
		Statistics: "Estatisticas",
		Analytics: "Analytics",
		CardActions: "Ações do Cartão",
		CardColors: "Cores do cartão",
		Table: "Mesa",
		agGridTable: "Tabela AgGrid",
		Components: "Componentes",
		Alert: "Alerta",
		Avatar: "Avatar",
		Badge: "Crachá",
		Breadcrumb: "Breadcrumb",
		Button: "Botão",
		ButtonGroup: "Grupo de botões",
		Chip: "Lasca",
		Collapse: "Colapso",
		Dialogs: "Diálogos",
		Divider: "Divisor",
		DropDown: "Suspenso",
		List: "Lista",
		Loading: "Carregando",
		Navbar: "Navbar",
		Notifications: "Notificações",
		Pagination: "Paginação",
		Popup: "Aparecer",
		Progress: "Progresso",
		Sidebar: "Barra Lateral",
		Slider: "Controle Deslizante",
		Tabs: "Guias",
		Tooltip: "dica de ferramenta",
		Upload: "Envio",
		FormsAndTable: "Formulários e tabela",
		FormElements: "Elementos do formulário",
		Select: "Selecione",
		Switch: "Interruptor",
		Checkbox: "Caixa de seleção",
		Radio: "Rádio",
		Input: "Entrada",
		NumberInput: "Entrada numérica",
		Textarea: "Textarea",
		FormLayouts: "Layouts de formulário",
		FormWizard: "Assistente de Formulário",
		FormValidation: "Validação de Formulário",
		FormInputGroup: "Grupo de entrada de formulário",
		Pages: "PÁGINAS",
		Authentication: "Autenticação",
		Login: "Entrar",
		Register: "Registo",
		ForgotPassword: "Esqueceu A Senha",
		ResetPassword: "Redefinir Senha",
		LockScreen: "Tela de bloqueio",
		Miscellaneous: "Diversos",
		ComingSoon: "Em breve",
		Error: "Erro",
		404: "404",
		500: "500",
		NotAuthorized: "Não autorizado",
		Maintenance: "Manutenção",
		Profile: "Perfil",
		User: "Do utilizador",
		View: "Visão",
		Edit: "Editar",
		UserSettings: "Configurações do Usuário",
		Invoice: "Fatura",
		FAQ: "Perguntas frequentes",
		Search: "Procurar",
		KnowledgeBase: "Base de Conhecimento",
		ChartsAndMaps: "Gráficos E Mapas",
		Charts: "Gráficos",
		ApexCharts: "Apex Charts",
		chartjs: "chartjs",
		echarts: "echarts",
		chartist: "chartist",
		GoogleMap: "Google Mapa",
		Extensions: "Extensão",
		QuillEditor: "Quill-Editor",
		DragAndDrop: "Arraste e solte",
		Datepicker: "Datepicker",
		DatetimePicker: "Seletor de data e hora",
		AccessControl: "Controle de acesso",
		I18n: "I18n",
		Carousel: "Carrossel",
		Clipboard: "Prancheta",
		ContextMenu: "Menu contextual",
		StarRatings: "Classificações por estrelas",
		Autocomplete: "autocompletar",
		Tree: "Árvore",
		// "Import/Export": "Importar/Exportar",
		Import: "Importar",
		Export: "Exportar",
		ExportSelected: "Exportar Selecionado",
		Others: "Outras",
		MenuLevels: "Níveis de Menu",
		MenuLevel2p1: "Nível de menu 2.1",
		MenuLevel2p2: "Nível de menu 2.2",
		MenuLevel3p1: "Nível de menu 3.1",
		MenuLevel3p2: "Nível de menu 3.2",
		DisabledMenu: "Menu desativado",
		Support: "Apoio, suporte",
		Documentation: "Documentação",
		RaiseSupport: "Levantar Suporte",
		demoTitle: "Título do cartão",
		demoText: "O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão."
	},
	tr: {
		invoiceNumber:"Numarası",
		Harvest: "Ürün Toplama",
		NotInList:"Barkod listede bulunmuyor",

		Appendant: "Eklenen",
		OrderItemBarcode: "Barkod",
		OrderItemId: "Id",
		OrderItemSellerCode: "Satıcı Kodu",
		OrderItemMarketPlaceCode: "Pazaryeri Kodu",
		OrderItemName: "Stok Adı",
		OrderItemPrice: "Fiyatı",
		OrderItemQuantity: "Adet",
		CompleteOrder: "Siparişi Tamamla",
		ClearList: "Listeyi Temizle",

		ProductItemList: "Ürün Kalem Listesi",

		CustumerBalance: "Firma Bakiyesi",

		SelectedOrdersTotalPrice: "Seçilen siparişlerin toplam tutarı ",
		PleaseIncreaseBalance: "Lütfen bakiyenizi artırın.",

		SelectedTotalHigerThenBalance: "Seçilen siparişlerin toplam tutarı cari bakiyesinden büyük olamaz!",
		GreaterThanQuantity:"Okutulan adet sipariş adedinden büyük olamaz.",
		Cargo: "Kargo",
		OrdersToInvoice: "Faturalandır",
		Recepient: "Alıcı",
		SellerCode: "Satıcı Kodu",

		Subtotal: "Ara toplam",
		PullStock: "Stok Çek",

		actWarning: "Borç yada alacak kısmı dolu olmalıdır",
		Payee: "Alacak",

		CreateDate: "Oluşturulma Tarihi",
		CustomerAct: "Cari Hareket",
		eArchiveClientKey: "E-Arşiv Anahtarı",
		eArchiveClientId: "E-Arşiv Id",
		Customer: "Müşteri",
		CustomerId: "Müşteri Id",
		CustomerMail: "Müşteri MAil",
		CustomerPhone: "Müşteri Telefon",
		InvoiceAddress: "Fatura Adresi",
		InvoiceCity: "Fatura Şehri",
		InvoiceCityCode: "Fatura Şehir Kodu",
		InvoiceCompany: "Fatura Müşterisi",
		InvoiceDistirct: "Fatura İlçesi",
		InvoiceIdentityNumber: "Tc",
		InvoiceLastName: "Fatura Soyad",
		InvoiceMail: "Fatura Mail",
		InvoiceName: "Fatura Ad",
		InvoicePhone: "Fatura Tel",
		InvoicePostalCode: "Fatura Posta Kodu",
		InvoiceTaxNumber: "Fatura Vergi Numarası",
		InvoiceTaxOffice: "Fatura Vergi Dairesi",

		OrderCargoName: "Kargo Adı",
		OrderCargoNumber: "Kargo Numarası",
		OrderCurrency: "Döviz",
		OrderDate: "Sipariş Tarihi",
		OrderId: "Sipariş Id",
		OrderNote: "Sipariş Notu",
		OrderNumber: "Sipariş Numarası",
		OrderPymentType: "Ödeme Tipi",
		OrderSource: "Sipariş Kaynağı",
		OrderStatus: "Sipariş Durumu",
		OrderWarehouseId: "Depo Id",
		ShipmentAddress: "Teslimat Adresi",
		ShipmentCity: "Teslimat Şehri",
		ShipmentCityCode: "Teslimat Şehir Kodu",
		ShipmentDistirct: "Teslimat İlçesi",
		ShipmentIdentityNumber: "Tc",
		ShipmentLastName: "Teslimat Soyad",
		ShipmentMail: "Teslimat mail",
		ShipmentName: "Teslimat Adı",
		ShipmentPhone: "Telimat Tel",
		ShipmentPostalCode: "Teslimat Posta Kodu",
		TotalPrice: "Toplam Fiyat",
		OrderDetails: "Sipariş Detayı",


		'shipmentAddress': "Teslimat Adresi", 'orderNumber': "Sipariş Numarası",
		'grossAmount': "Brüt tutar", 'totalDiscount': "Toplam İndirim", 'totalTyDiscount': "Toplam Ty İndirim",
		'taxNumber': "Vargi Numarası", 'invoiceAddress': "Fatura Adresi", 'customerFirstName': "Müşteri ADı",
		'customerEmail': "Müşteri Maili", 'customerId': "Müşteri Id'si", 'customerLastName': "Müşteri Soyadı",
		'cargoTrackingNumber': "Kargo Takip Numarası", 'cargoProviderName': "Kargo",
		'orderDate': "Sipariş Tarihi", 'tcIdentityNumber': "Tc", 'currencyCode': "Döviz", 'shipmentPackageStatus': "Teslimat Paketleme Durumu",
		'status': "Durum", 'deliveryType': "Teslimat Tipi", 'estimatedDeliveryStartDate': "Tahmini Teslimat Başlangıç Tarihi",
		'estimatedDeliveryEndDate': "Tahmini Teslimat Bitiş Tarihi", 'totalPrice': "Toplam Fiyat", 'deliveryAddressType': "Taslimat Adres Tipi",
		'agreedDeliveryDate': "Anlaşılan Teslim Tarihi", 'fastDelivery': "Hızlı Teslimat", 'fastDeliveryType': "Hızlı Telimat Tipi",
		'warehouseId': "Depo Id", 'giftBoxRequested': "Hediye Kutusu Talebi",
		Brand: "Marka",

		Prefix: "Ön Ek Kodu",
		PullOrder: "Sipariş Çek",

		AddWholeExcel: "Excel ile Toplu Ekle",
		Download: "İndir",
		Actions: "İşlemler",
		SampleExcel: "Örnek Excel Şablonu",
		AddExcel: "Excel ile Kaydet",
		AddNewDepotSupplier: "Tedarik Deposu Ekle",
		DepotCompanyInfoName: "Pazaryeri Ad",
		DepotCompanyName: "Firma Ad",
		DepotName: "Depo Ad",
		DepotNo: "Depo No",
		UsingDropShiping: "Tedarikçi Deposu",
		DropShipingDepot: "Tedarikçi Deposu",

		DropShiping: "Tedarikçi Durumu",
		TotalActions: "Toplu İşlemler",

		TotalAct: "Toplu Stok Hareketi Ekle",
		OrderList: "Sipariş Listesi",
		Order: "Sipariş",
		"StockAct": "Stok Hareketi",
		Account: "Hesap",
		Currency: "Döviz",
		Vat: "KDV",
		Other: "Diğer",
		Marketplace: "Pazaryeri",

		CargoDefinationId: "Kargo Tanımı",
		Price: "Fiyat",
		ShippingType: "Teslimat Tipi",
		ShippingDay: "Teslimat Günü",
		CompanyId: "Firma",
		DepotId: "Depo",

		addCargo: "Kargo Tanımlama",

		PalletDetails: "Palet Detayı",
		UserCreate: "Kullanıcı Oluştur",

		Detail: "Detay",

		Address: "Adres",
		Contact: "İletişim",
		Special: "Özel",
		Tax: "Vergi",
		General: "Genel",
		AddStock: "Stok Ekle",
		AddBarcode: "Barkod Ekle",

		AddPalletItems: "Palet Stoğu Ekle",

		Clear: "Temizle",

		PalletCreate: "Palet Oluştur",
		PalletNo: "Palet No",
		StockCode: "Stok Kod",
		Barcode: "Barkod",
		Quantity: "Adet",
		PalletId: "Palet",
		Height: "Yükseklik",
		Width: "Genişlik",
		Depth: "Derinlik",
		Dept: "Borç",
		Weight: "Ağırlık",
		PalletIsOpen: "Açık mı",
		PalletJobDone: "Palet bitti",
		ProductTrackingId: "Stok Takip",
		ProductTrackingName: "Stok Takip Adı",
		ProductTrackingDescription: "Stok Takip Açıklaması",
		ProductTrackingType: "Stok Takip Tipi",
		ProductTrackingNo: "Stok Takip No",
		StockTracking: "Stok Takip",
		StockTrackingList: "Stok Takip Listesi",
		IsTracking: "Takip ediliyor mu",


		Company: "Firma",
		Stock: "Stok",
		StorehouseManagement: "Depo Yönetimi",
		CompanyManagement: "Müşteri Yönetimi",

		Validate: "Eksik alanları kontrol edin",
		GroupGode: "Grup Kod",
		EmployeeAddNew: "Yeni Çalışan Ekle",
		EmployeeId: "Çalışan",
		EmployeeNo: "Çalışan No",
		EmployeeName: "Çalışan Name",
		FisrtName: "Ad",
		LastName: "Soyad",
		EnteryDate: "Giriş Tarihi",
		ExitDate: "Çıkış Tarihi",
		SpecCodeUnvan: "Özel Kod Unvan",
		CompnayId: "Firma",

		List: "Listele",
		StockBarcodeId: "Stok Barkod",
		UnitId: "Birim",
		ItemNo: "Nesne",
		BarcodeType: "Barkod Tipi",
		Barcode: "Barkod",
		AddStockBarcode: "Stok Barkodu Ekle",
		StockId: "Stok",

		CustomerStockNo: "Müşteri Stok No",

		Wholesale: "Toptan",

		Languages: "Diller",
		Storehouse: "Depo",
		StoreHosueName: "Depo Detay Adı",
		StoreHosueId: "Depo Detay",
		StoreHosueNo: "Depo Detay No",
		StorehosueName: "Depo Detay Ad",
		Disdance: "Mesafe",
		Floor: "Kat",
		Hall: "Hol",
		Preference: "Öncelik",
		MyProperty: "Özelliğim",
		DepotId: "Depo",
		CompanyInfoName: "Firma Detay Adı",

		CompanyInfo: "Firma Bilgisi",
		"Stockno": "Stok No",
		"StockName": "Stok Adı",
		"SpecCode3": "Özel Kod 3",
		"SpecCode4": "Özel Kod 4",
		"SpecCode5": "Özel Kod 5",
		"SpecCode6": "Özel Kod 6",
		"SpecCode7": "Özel Kod 7",
		"SpecCode8": "Özel Kod 8",
		"SpecCode9": "Özel Kod 9",
		"SpecCode10": "Özel Kod 10",
		"Debit": "Borç",
		"Credit": "Alacak",
		"RemTotal": "Bakiye Toplam",
		"RemType": "Bakiye Tipi",
		"CurrCode": "Döviz Kod",
		"CurrDebit": "Döviz Borç",
		"CurrCredit": "Döviz Alacak",
		"CurrRemTotal": "Döviz Bakiye Toplam",
		"CurrRemType": "Döviz Bakiye Tipi",
		"QEntery": "Giriş Adet",
		"QExit": "Çıkış Adet",
		"QRem": "Bakiye Adet",
		"QRem2": "Bakiye Adet 2",
		"QRem3": "Bakiye Adet 3",
		"QReserve": "Reserve Adet",
		"QReserve2": "Reserve Adet 2",
		"QReserve3": "Reserve Adet 3",
		"QDepot": "Depo Adet",
		"StockName2": "Stok Adı 2",
		"UnitId": "Birim",
		"VatSales": "Kdv Satış",
		"VatPurChase": "Vat PurChase",
		"QuantityMin": "Adet Min",
		"QuantityMax": "Adet Max",
		"minOrderQuantity": "Min Sipariş Adet",
		"taxPrivate": "Özel Vergi",
		"taxPrivateTotal": "Özel Vergi Toplamı",
		"ordersLevel": "Sipariş Seviyesi",
		"actSupplierId": "Tedarikçi",
		"packageQuantity": "Paket Adedi",
		"customerStockNo": "Müşteri Stok No",
		"msg": "msg",
		"minReqQuantity": "Min Req Adet",
		"transCode": "TransCode",
		"origin": "Origin",
		"qtyTree": "Adet Ağacı",
		"depotId": "Depo",

		FirstNameRequired: "Ad gereklidir",
		shippingTypeRequired: "Teslimat Tipi gereklidir",
		shippingDayRequired: "Teslimat Günü gereklidir",
		priceRequired: "Teslimat Fiyatı gereklidir",
		MinRequired5: "Bu ürün en az beş karakter içermelidir",
		ProductTrackingNameRequired: "Stok Takip adı gereklidir",
		ProductTrackingNoNameRequired: "Stok Takip numarası gereklidir",
		ProductTrackingTypeNameRequired: "Stok Takip tipi gereklidir",
		ProductTrackingDescriptionNameRequired: "Stok Takip açıklaması gereklidir",
		StocknoRequired: "Stok Numarası gereklidir",
		StockNameRequired: "Stok Adı gereklidir",
		brandRequired: "MArka gereklidir",
		customerinfoNameRequired: "Firma detay adı gereklidir",
		DepotNoRequired: "Depo numarası gereklidir.",
		DepotNameRequired: "Depo adı gereklidir.",
		LastNameRequired: "Soyad gereklidir",
		EmployeeNameRequired: "Çalışan Adı gereklidir",
		EmployeeNoRequired: "Çalışan No gereklidir",
		apipasswordRequired: "Api şifresi gereklidir",
		apiprefixRequired: "Api prefix kod gereklidir",
		apiuserRequired: "Api kullanıcısı gereklidir",
		apiKeyRequired: "Api anahtarı gereklidir",
		mpnameRequired: "Firma detayı gereklidir",
		storehosueNameRequired: "Depo detay adı gereklidir",
		storeHosueNoRequired: "Depo detay numarası gereklidir",
		storehouseRequired: "Depo gereklidir",
		RoleRequired: "Rol gereklidir",
		customerRequired: "Firma gereklidir",
		stocknoRequired: "Stok No gereklidir",
		customerStockNoRequired: "Firma Stok No gereklidir",
		stocknameRequired: "Stok Adı gereklidir",
		"DepotType": 0,
		"DepotNo": "Depo Numarası",
		"DepotName": "Depo Adı",
		"Note": "Not",
		"RemControl": "Bakiye Kontrolü",
		Stock: "Stok",
		StoreHouse: "Depo",
		MpAdd: "Pazaryeri Ekle",

		MpName: "Pazaryeri Adı",

		ImageSize: "Resim boyutu 1024'den küçük olmalı",
		Delete: "Sil",
		Image: "Resim",

		NoConnection: "Erişim Yok",
		LoginUnauthorized: "Giriş bilgilerinizi tekrar kontrol ediniz",
		Wait: "Lütfen bekleyin",
		Error: "Hata",
		Success: "Başarılı",
		LoginSuccess: "Giriş yapılıyor",
		CompanynoRequired: "Müşteri Numarası gereklidir",
		PasswordRequired: "Şifre gereklidir.",
		Password: "Şifre",
		UserName: "Kullanıcı Adı",
		UsernameRequired: "Kullanıcı adı gereklidir.",
		CompanyNameRequired: "Müşteri Adı gereklidir.",
		CompanyNoRequired: "Müşteri No gereklidir.",
		LoginInfo: "Lütfen giriş bilgilerinizi giriniz",
		LoginAlready: "Zaten giriş yaptınız!",
		Warning: "Uyarı",
		DeleteWarning: "Silmek istediğinize emin misiniz?",
		AreYSure: "Emin misiniz?",
		CantUndo: "Bunu geri alamazsınız.",


		Cancel: "İptal",
		Submit: "Onayla",
		FinishDate: "Bitiş Tarihi",
		StartDate: "Başlangıç Tarihi",
		PostCode: "Posta Kodu",
		City: "Şehir",
		Country: "Ülke",
		Town: "Mahalle",

		Address: "Adres",
		Address1: "Adres 1",
		Address2: "Adres 2",
		Address3: "Address 3",

		ChanelDate: "İptal Tarihi",

		CompanyLogo: "Firma Logo",

		CompanyName2: "Firma Ad 2",

		CompanySignLogo: "Firma İmza Logo",


		PhohneAreaCode: "Telefon Alan kodu",

		Phone2: "Telefon 2",

		SpecCode1: "Özel Kod 1",
		SpecCode2: "Özel Kod 2",

		ConfirmToInvoiceInfo: "Seçilen siparişler faturalandırılacak.",
		ConfirmToSelected: "Seçim ypınız.",

		CurrCode: "Döviz",
		TaxCity: "Vergi Şehri",
		TaxNo: "Vergi Numarası",
		TaxOfficeCode: "Vergi Dairesi Kodu",
		TaxOffice: "Vergi Dairesi",
		Phone: "Telefon",
		PhoneAreaCode: "Alan Kodu",
		ContactName: "İletişim",
		Description: "Açıklama",
		CancelDate: "İptal Tarihi",
		Active: "Aktif",
		Passive: "Pasif",
		Status: "Durum",
		SpecCode: "Özel Kod",
		GroupCode: "Grup Kodu",
		UPDATE: "Güncelle",
		Contacts: "İletişim",
		CompanyNo: "Müşteri No",
		CompanyName: "Müşteri Adı",
		Customer: "Müşteri",
		CustomerList: "Müşteri Listesi",
		AddNew: "Yeni Ekle",
		UserDefinition: "Kullanıcı Tanımlama",
		Save: "Kaydet",
		RoleName: "Rol Adı: ",
		RoleDefinition: "Rol Tanımlama",
		SearchNotFound: "Sonuç bulunamadı.",
		searchTitle: "Ara...",
		Logout: "Çıkış",
		dashboardDeneme: "Anaaa",
		Dashboard: "Anasayfa",
		eCommerce: "eTicaret",
		Apps: "Uygulamalar",
		Todo: "Yapılacaklar",
		Chat: "Mesajlaşma",
		Email: "Email",
		Calendar: "Takvim",
		FullCalendar: "Tüm Takvim",
		SimpleCalendar: "Basit Takvim",
		Shop: "Alışveriş",
		ItemDetails: "Ürün Detay",
		Cart: "Sepet",
		WishList: "Favoriler",
		Checkout: "Ödeme",
		UI: "UI",
		DataList: "Veri Listesi",
		ListView: "Liste Görünüm",
		ThumbView: "Mandal Görünüm",
		Grid: "Grid",
		Vuexy: "Vuexy",
		Vuesax: "Vuesax",
		Tailwind: "Tailwind",
		Colors: "Colors",
		Card: "Card",
		Basic: "Basic",
		Statistics: "İstatistikler",
		Analytics: "Analizler",
		CardActions: "Sepet Hareketi",
		CardColors: "Sepet Rengi",
		Table: "Table",
		agGridTable: "agGrid Table",
		Components: "Components",
		Alert: "Alert",
		Avatar: "Avatar",
		Badge: "Badge",
		Breadcrumb: "Breadcrumb",
		Button: "Button",
		ButtonGroup: "Button Group",
		Chip: "Chip",
		Collapse: "Collapse",
		Dialogs: "Dialogs",
		Divider: "Divider",
		DropDown: "DropDown",
		Loading: "Loading",
		Navbar: "Navbar",
		Notifications: "Notifications",
		Pagination: "Pagination",
		Popup: "Popup",
		Progress: "Progress",
		Sidebar: "Sidebar",
		Slider: "Slider",
		Tabs: "Tabs",
		Tooltip: "Tooltip",
		Upload: "Yükle",
		FormsAndTable: "Forms & Table",
		FormElements: "Form Elements",
		Select: "Select",
		Switch: "Switch",
		Checkbox: "Checkbox",
		Radio: "Radio",
		Input: "Input",
		NumberInput: "Number Input",
		Textarea: "Textarea",
		FormLayouts: "Form Layouts",
		FormWizard: "Form Wizard",
		FormValidation: "Form Validation",
		FormInputGroup: "Form Input Group",
		Pages: "Pages",
		Authentication: "Authentication",
		Login: "Giriş",
		Register: "Register",
		ForgotPassword: "Forgot Password",
		ResetPassword: "Reset Password",
		LockScreen: "Lock Screen",
		Miscellaneous: "Miscellaneous",
		ComingSoon: "Coming Soon",
		Error: "Error",
		404: "404",
		500: "500",
		NotAuthorized: "Not Authorized",
		Maintenance: "Maintenance",
		Profile: "Profil",
		User: "User",
		View: "Görüntüle",
		Edit: "Düzenle",
		UserSettings: "User Settings",
		Invoice: "Invoice",
		FAQ: "FAQ",
		Search: "Ara",
		KnowledgeBase: "Knowledge Base",
		ChartsAndMaps: "Charts & Maps",
		Charts: "Charts",
		ApexCharts: "Apex Charts",
		chartjs: "chartjs",
		echarts: "echarts",
		chartist: "chartist",
		GoogleMap: "Google Map",
		Extensions: "Extensions",
		QuillEditor: "Quill Editor",
		DragAndDrop: "Drag & Drop",
		Datepicker: "Datepicker",
		DatetimePicker: "Datetime Picker",
		AccessControl: "Access Control",
		I18n: "I18n",
		Carousel: "Carousel",
		Clipboard: "Clipboard",
		ContextMenu: "Context Menu",
		StarRatings: "Star Ratings",
		Autocomplete: "Autocomplete",
		Tree: "Tree",
		// "Import/Export": "Import/Export",
		Import: "Import",
		Export: "Export",
		ExportSelected: "Export Selected",
		Others: "Others",
		MenuLevels: "Menu Levels",
		MenuLevel2p1: "Menu Level 2.1",
		MenuLevel2p2: "Menu Level 2.2",
		MenuLevel3p1: "Menu Level 3.1",
		MenuLevel3p2: "Menu Level 3.2",
		DisabledMenu: "Disabled Menu",
		Support: "Support",
		Documentation: "Documentation",
		RaiseSupport: "Raise Support",
		demoTitle: "Card Title",
		demoText: "Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.",
		// Set Filter
		selectAll: "(Tümünü Seç)",
		selectAllSearchResults: "(Tüm aranan değerleri seç)",
		searchOoo: "Arama...",
		blanks: "(Boşluk)",
		noMatches: "Eşleşme yok",

		// Number Filter & Text Filter
		filterOoo: "Filtrele...",
		equals: "Eşit",
		notEqual: "Eşit Olmayan",
		blank: "Boş Olanlar",
		notBlank: "Boş Olmayanlar",
		empty: "Birini Seç",

		// Number Filter
		lessThan: "Daha Küçük",
		greaterThan: "Daha Büyük",
		lessThanOrEqual: "Daha Küçük veya Eşit",
		greaterThanOrEqual: "Daha Büyük veya Eşit",
		inRange: "Arasında",
		inRangeStart: "dan",
		inRangeEnd: "dan a",

		// Text Filter
		contains: "İçeren",
		notContains: "İçermeyen",
		startsWith: "ile Başlayan",
		endsWith: "ile Biten",

		// Date Filter
		dateFormatOoo: "yyyy-mm-dd",

		// Filter Conditions
		andCondition: "VE",
		orCondition: "VEYA",

		// Filter Buttons
		applyFilter: "Tamam",
		resetFilter: "Resetle",
		clearFilter: "Temizle",
		cancelFilter: "iptal",

		// Filter Titles
		textFilter: "Text Filter",
		numberFilter: "Number Filter",
		dateFilter: "Date Filter",
		setFilter: "Set Filter",

		// Side Bar
		columns: "Columns",
		filters: "Filters",

		// columns tool panel
		pivotMode: "Pivot Mode",
		groups: "Row Groups",
		rowGroupColumnsEmptyMessage: "Drag here to set row groups",
		values: "Values",
		valueColumnsEmptyMessage: "Drag here to aggregate",
		pivots: "Column Labels",
		pivotColumnsEmptyMessage: "Drag here to set column labels",

		// Header of the Default Group Column
		group: "Gruplama",

		// Row Drag
		rowDragRows: "rows",

		// Other
		loadingOoo: "Bekleniyor...",
		noRowsToShow: "Gösterilecek kayıt bulunamadı",
		enabled: "Enabled",

		// Menu
		pinColumn: "Sabitle",
		pinLeft: "Sola Sabitle",
		pinRight: "Sağa Sabitle",
		noPin: "Sabitleme",
		valueAggregation: "Value Aggregation",
		autosizeThiscolumn: "Otomatik boyutla",
		autosizeAllColumns: "Tümünü Otomatik boyutla",
		groupBy: "Group by",
		ungroupBy: "Un-Group by",
		addToValues: "Add ${variable} to values",
		removeFromValues: "Remove ${variable} from values",
		addToLabels: "Add ${variable} to labels",
		removeFromLabels: "Remove ${variable} from labels",
		resetColumns: "Resetle",
		expandAll: "Grupları Aç",
		collapseAll: "Grupları Kapat",
		copy: "Kopyala",
		ctrlC: "Ctrl+C",
		copyWithHeaders: "Başlıkla kopyala",
		copyWithHeaderGroups: "Grupların Başlığı ile kopyala",
		paste: "Yapıştır",
		ctrlV: "Ctrl+V",
		export: "Dışa aktar",
		csvExport: "CSV Export",
		excelExport: "Excel Export",

		// Enterprise Menu Aggregation and Status Bar
		sum: "Sum",
		min: "Min",
		max: "Max",
		none: "None",
		count: "Count",
		avg: "Average",
		filteredRows: "Filtered",
		selectedRows: "Selected",
		totalRows: "Total Rows",
		totalAndFilteredRows: "Rows",
		more: "More",
		to: "to",
		of: "of",
		page: "Sayfa",
		nextPage: "Sonraki Sayfa",
		lastPage: "Son Sayfa",
		firstPage: "İlk Sayfa",
		previousPage: " Önceki Sayfa",

		// Pivoting
		pivotColumnGroupTotals: "Toplam",

		// Enterprise Menu (Charts)
		pivotChartAndPivotMode: "Pivot Chart & Pivot Mode",
		pivotChart: "Pivot Chart",
		chartRange: "Chart Range",

		columnChart: "Column",
		groupedColumn: "Grouped",
		stackedColumn: "Stacked",
		normalizedColumn: "100% Stacked",

		barChart: "Bar",
		groupedBar: "Grouped",
		stackedBar: "Stacked",
		normalizedBar: "100% Stacked",

		pieChart: "Pie",
		pie: "Pie",
		doughnut: "Doughnut",

		line: "Line",

		xyChart: "X Y (Scatter)",
		scatter: "Scatter",
		bubble: "Bubble",

		areaChart: "Area",
		area: "Area",
		stackedArea: "Stacked",
		normalizedArea: "100% Stacked",

		histogramChart: "Histogram",

		combinationChart: "Combination",
		columnLineCombo: "Column & Line",
		AreaColumnCombo: "Area & Column",

		// Charts
		pivotChartTitle: "Pivot Chart",
		rangeChartTitle: "Range Chart",
		settings: "Settings",
		data: "Data",
		format: "Format",
		categories: "Categories",
		defaultCategory: "(None)",
		series: "Series",
		xyValues: "X Y Values",
		paired: "Paired Mode",
		axis: "Axis",
		navigator: "Navigator",
		color: "Color",
		thickness: "Thickness",
		xType: "X Type",
		automatic: "Automatic",
		category: "Category",
		number: "Number",
		time: "Time",
		xRotation: "X Rotation",
		yRotation: "Y Rotation",
		ticks: "Ticks",
		width: "Width",
		height: "Height",
		length: "Length",
		padding: "Padding",
		spacing: "Spacing",
		chart: "Chart",
		title: "Title",
		titlePlaceholder: "Chart title - double click to edit",
		background: "Background",
		font: "Font",
		top: "Top",
		right: "Right",
		bottom: "Bottom",
		left: "Left",
		labels: "Labels",
		size: "Size",
		minSize: "Minimum Size",
		maxSize: "Maximum Size",
		legend: "Legend",
		position: "Position",
		markerSize: "Marker Size",
		markerStroke: "Marker Stroke",
		markerPadding: "Marker Padding",
		itemSpacing: "Item Spacing",
		itemPaddingX: "Item Padding X",
		itemPaddingY: "Item Padding Y",
		layoutHorizontalSpacing: "Horizontal Spacing",
		layoutVerticalSpacing: "Vertical Spacing",
		strokeWidth: "Stroke Width",
		offset: "Offset",
		offsets: "Offsets",
		tooltips: "Tooltips",
		callout: "Callout",
		markers: "Markers",
		shadow: "Shadow",
		blur: "Blur",
		xOffset: "X Offset",
		yOffset: "Y Offset",
		lineWidth: "Line Width",
		normal: "Normal",
		bold: "Bold",
		italic: "Italic",
		boldItalic: "Bold Italic",
		predefined: "Predefined",
		fillOpacity: "Fill Opacity",
		strokeOpacity: "Line Opacity",
		histogramBinCount: "Bin count",
		columnGroup: "Column",
		barGroup: "Bar",
		pieGroup: "Pie",
		lineGroup: "Line",
		scatterGroup: "X Y (Scatter)",
		areaGroup: "Area",
		histogramGroup: "Histogram",
		combinationGroup: "Combination",
		groupedColumnTooltip: "Grouped",
		stackedColumnTooltip: "Stacked",
		normalizedColumnTooltip: "100% Stacked",
		groupedBarTooltip: "Grouped",
		stackedBarTooltip: "Stacked",
		normalizedBarTooltip: "100% Stacked",
		pieTooltip: "Pie",
		doughnutTooltip: "Doughnut",
		lineTooltip: "Line",
		groupedAreaTooltip: "Area",
		stackedAreaTooltip: "Stacked",
		normalizedAreaTooltip: "100% Stacked",
		scatterTooltip: "Scatter",
		bubbleTooltip: "Bubble",
		histogramTooltip: "Histogram",
		columnLineComboTooltip: "Column & Line",
		areaColumnComboTooltip: "Area & Column",
		customComboTooltip: "Custom Combination",
		noDataToChart: "No data available to be charted.",
		pivotChartRequiresPivotMode: "Pivot Chart requires Pivot Mode enabled.",
		chartSettingsToolbarTooltip: "Menu",
		chartLinkToolbarTooltip: "Linked to Grid",
		chartUnlinkToolbarTooltip: "Unlinked from Grid",
		chartDownloadToolbarTooltip: "Download Chart",
		seriesChartType: "Series Chart Type",
		seriesType: "Series Type",
		secondaryAxis: "Secondary Axis",

		// ARIA
		ariaHidden: "hidden",
		ariaVisible: "visible",
		ariaChecked: "checked",
		ariaUnchecked: "unchecked",
		ariaIndeterminate: "indeterminate",
		ariaDefaultListName: "List",
		ariaColumnSelectAll: "Toggle Select All Columns",
		ariaInputEditor: "Input Editor",
		ariaDateFilterInput: "Date Filter Input",
		ariaFilterList: "Filter List",
		ariaFilterInput: "Filter Input",
		ariaFilterColumnsInput: "Filter Columns Input",
		ariaFilterValue: "Filter Value",
		ariaFilterFromValue: "Filter from value",
		ariaFilterToValue: "Filter to value",
		ariaFilteringOperator: "Filtering Operator",
		ariaColumn: "Column",
		ariaColumnList: "Column List",
		ariaColumnGroup: "Column Group",
		ariaRowSelect: "Press SPACE to select this row",
		ariaRowDeselect: "Press SPACE to deselect this row",
		ariaRowToggleSelection: "Press Space to toggle row selection",
		ariaRowSelectAll: "Press Space to toggle all rows selection",
		ariaToggleVisibility: "Press SPACE to toggle visibility",
		ariaSearch: "Search",
		ariaSearchFilterValues: "Search filter values",

		ariaRowGroupDropZonePanelLabel: "Row Groups",
		ariaValuesDropZonePanelLabel: "Values",
		ariaPivotDropZonePanelLabel: "Column Labels",
		ariaDropZoneColumnComponentDescription: "Press DELETE to remove",
		ariaDropZoneColumnValueItemDescription:
			"Press ENTER to change the aggregation type",

		// ARIA Labels for Dialogs
		ariaLabelColumnMenu: "Column Menu",
		ariaLabelCellEditor: "Cell Editor",
		ariaLabelDialog: "Dialog",
		ariaLabelSelectField: "Select Field",
		ariaLabelTooltip: "Tooltip",
		ariaLabelContextMenu: "Context Menu",
		ariaLabelSubMenu: "SubMenu",
		ariaLabelAggregationFunction: "Aggregation Function",

		// Number Format (Status Bar, Pagination Panel)
		thousandSeparator: ",",
		decimalSeparator: ".",
	},
	uz: {
		SpecCode: "",
		GroupCode: "",
		UPDATE: "",
		Contacts: "",
		CompanyNo: "",
		CompanyName: "",
		Customer: "",
		CustomerList: "",
		AddNew: "Yangi qo'shing",
		Save: "Foydalanuvchi yaratish",
		RoleName: "Rol nomi: ",
		RoleDefinition: "Rol ta'rifi",
		SearchNotFound: "Natija yo'q edi.",
		searchTitle: "Qidirmoq...",
		Logout: "Chiqish",
		dashboardDeneme: "Anaaa",
		Dashboard: "Bosh Sahifa",
		eCommerce: "eCommerce",
		Apps: "Apps",
		Todo: "Todo",
		Chat: "Chat",
		Email: "Email",
		Calendar: "Calendar",
		FullCalendar: "Full Calendar",
		SimpleCalendar: "Simple Calendar",
		Shop: "Shop",
		ItemDetails: "Item Details",
		Cart: "Cart",
		WishList: "Wish List",
		Checkout: "Checkout",
		UI: "UI",
		DataList: "Data List",
		ListView: "List View",
		ThumbView: "Thumb View",
		Grid: "Grid",
		Vuexy: "Vuexy",
		Vuesax: "Vuesax",
		Tailwind: "Tailwind",
		Colors: "Colors",
		Card: "Card",
		Basic: "Basic",
		Statistics: "Statistics",
		Analytics: "Analytics",
		CardActions: "Card Actions",
		CardColors: "Card Colors",
		Table: "Table",
		agGridTable: "agGrid Table",
		Components: "Components",
		Alert: "Alert",
		Avatar: "Avatar",
		Badge: "Badge",
		Breadcrumb: "Breadcrumb",
		Button: "Button",
		ButtonGroup: "Button Group",
		Chip: "Chip",
		Collapse: "Collapse",
		Dialogs: "Dialogs",
		Divider: "Divider",
		DropDown: "DropDown",
		List: "List",
		Loading: "Loading",
		Navbar: "Navbar",
		Notifications: "Notifications",
		Pagination: "Pagination",
		Popup: "Popup",
		Progress: "Progress",
		Sidebar: "Sidebar",
		Slider: "Slider",
		Tabs: "Tabs",
		Tooltip: "Tooltip",
		Upload: "Upload",
		FormsAndTable: "Forms & Table",
		FormElements: "Form Elements",
		Select: "Select",
		Switch: "Switch",
		Checkbox: "Checkbox",
		Radio: "Radio",
		Input: "Input",
		NumberInput: "Number Input",
		Textarea: "Textarea",
		FormLayouts: "Form Layouts",
		FormWizard: "Form Wizard",
		FormValidation: "Form Validation",
		FormInputGroup: "Form Input Group",
		Pages: "Pages",
		Authentication: "Authentication",
		Login: "Kirish",
		Register: "Register",
		ForgotPassword: "Forgot Password",
		ResetPassword: "Reset Password",
		LockScreen: "Lock Screen",
		Miscellaneous: "Miscellaneous",
		ComingSoon: "Coming Soon",
		Error: "Error",
		404: "404",
		500: "500",
		NotAuthorized: "Not Authorized",
		Maintenance: "Maintenance",
		Profile: "Profil",
		User: "User",
		View: "View",
		Edit: "Edit",
		UserSettings: "User Settings",
		Invoice: "Invoice",
		FAQ: "FAQ",
		Search: "Search",
		KnowledgeBase: "Knowledge Base",
		ChartsAndMaps: "Charts & Maps",
		Charts: "Charts",
		ApexCharts: "Apex Charts",
		chartjs: "chartjs",
		echarts: "echarts",
		chartist: "chartist",
		GoogleMap: "Google Map",
		Extensions: "Extensions",
		QuillEditor: "Quill Editor",
		DragAndDrop: "Drag & Drop",
		Datepicker: "Datepicker",
		DatetimePicker: "Datetime Picker",
		AccessControl: "Access Control",
		I18n: "I18n",
		Carousel: "Carousel",
		Clipboard: "Clipboard",
		ContextMenu: "Context Menu",
		StarRatings: "Star Ratings",
		Autocomplete: "Autocomplete",
		Tree: "Tree",
		// "Import/Export": "Import/Export",
		Import: "Import",
		Export: "Export",
		ExportSelected: "Export Selected",
		Others: "Others",
		MenuLevels: "Menu Levels",
		MenuLevel2p1: "Menu Level 2.1",
		MenuLevel2p2: "Menu Level 2.2",
		MenuLevel3p1: "Menu Level 3.1",
		MenuLevel3p2: "Menu Level 3.2",
		DisabledMenu: "Disabled Menu",
		Support: "Support",
		Documentation: "Documentation",
		RaiseSupport: "Raise Support",
		demoTitle: "Card Title",
		demoText: "Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops."
	},
}
